import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { useFeatureAccess } from '@/hooks/use-feature-access';

/**
 * If the user cannot use the `low-contrast` feature (or it is still loading and we later deny),
 * force theme off `lowcontrast` so persisted preference cannot keep an inaccessible mode.
 */
export default function LowContrastThemeGuard() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const { hasAccess, isLoading } = useFeatureAccess('low-contrast');

  useEffect(() => {
    if (isLoading) return;
    if (hasAccess) return;
    const active = theme === 'lowcontrast' || resolvedTheme === 'lowcontrast';
    if (active) {
      setTheme('light');
    }
  }, [isLoading, hasAccess, theme, resolvedTheme, setTheme]);

  return null;
}
